import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function QCByPlant() {
  const [data, setData] = useState([]);
  useEffect(() => { api.get("/qc/by-plant").then((r) => setData(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="qc-by-plant-page">
      <header>
        <div className="text-[11px] tracking-[0.35em] uppercase text-[#00D4FF]">07 · QC by Plant</div>
        <h1 className="font-heading font-bold text-4xl tracking-tight mt-2">Quality by Plant</h1>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {data.map((p) => (
          <div key={p.plant} className="bg-[#12141D] border border-border p-5">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-muted-foreground">Facility</div>
                <div className="font-heading font-bold text-xl">{p.plant}</div>
              </div>
              <div className={`text-xs uppercase tracking-widest px-2 py-1 border
                ${p.pass_rate >= 90 ? "border-emerald-500/30 text-emerald-300 bg-emerald-500/10"
                  : p.pass_rate >= 75 ? "border-amber-500/30 text-amber-300 bg-amber-500/10"
                  : "border-red-500/30 text-red-300 bg-red-500/10"}`}
              >
                {p.pass_rate}% PASS
              </div>
            </div>

            <div className="mt-6">
              <div className="h-2 bg-[#1A1C28]">
                <div className="h-full bg-[#00D4FF]" style={{ width: `${p.pass_rate}%` }} />
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3 mt-5 pt-4 border-t border-border text-center">
              <div>
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Total</div>
                <div className="font-mono text-lg">{p.total}</div>
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">Passed</div>
                <div className="font-mono text-lg text-emerald-300">{p.passed}</div>
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-widest text-muted-foreground">NCRs</div>
                <div className="font-mono text-lg text-red-300">{p.ncr}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
